import { render, staticRenderFns } from "./CalendarProviderComponent.vue?vue&type=template&id=3a53a288&"
import script from "./CalendarProviderComponent.vue?vue&type=script&lang=ts&"
export * from "./CalendarProviderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports